module.exports = __webpack_public_path__ + "img/771.e3f12fe6.jpg";